import { render, staticRenderFns } from "./assignUsersCatalogue.vue?vue&type=template&id=7a1e3ed4&scoped=true"
import script from "./assignUsersCatalogue.vue?vue&type=script&lang=js"
export * from "./assignUsersCatalogue.vue?vue&type=script&lang=js"
import style0 from "./assignUsersCatalogue.vue?vue&type=style&index=0&id=7a1e3ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1e3ed4",
  null
  
)

export default component.exports